import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Headset, Trash2, UserPlus, Loader2 } from "lucide-react";
import { SupportReport } from "@/components/support/SupportReport";

const EMPTY = { name: "", email: "", password: "" };

export function SupportAgents() {
  const navigate = useNavigate();
  const [agents, setAgents] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const { data } = await api.get("/admin/support-agents");
    setAgents(data);
  };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/admin/support-agents", form);
      toast.success("تمت إضافة موظف خدمة العملاء");
      setForm(EMPTY); load();
    } catch (ex) {
      toast.error(formatApiError(ex.response?.data?.detail));
    }
    setBusy(false);
  };

  const remove = async (a) => {
    if (!window.confirm(`حذف حساب ${a.name}؟`)) return;
    await api.delete(`/admin/support-agents/${a.id}`);
    toast.success("تم حذف الحساب"); load();
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="space-y-5" data-testid="support-agents">
      <Card className="p-5 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="font-bold">واجهة خدمة العملاء</h3>
          <p className="text-sm text-muted-foreground">موظفو الدعم يدخلون من صفحة تسجيل الدخول العادية ويرون التذاكر فقط.</p>
        </div>
        <Button className="rounded-full gap-2" onClick={() => navigate("/support-desk")} data-testid="open-support-desk-btn">
          <Headset className="w-4 h-4" /> فتح واجهة خدمة العملاء
        </Button>
      </Card>
      <SupportReport />
      <Card className="p-5">
        <h3 className="font-bold mb-3">إضافة موظف دعم</h3>
        <form onSubmit={add} className="grid sm:grid-cols-4 gap-3">
          <Input placeholder="الاسم" value={form.name} onChange={set("name")} data-testid="agent-name-input" />
          <Input placeholder="البريد الإلكتروني" type="email" dir="ltr" value={form.email} onChange={set("email")} data-testid="agent-email-input" />
          <Input placeholder="كلمة المرور (10 أحرف وأرقام)" type="password" dir="ltr" value={form.password} onChange={set("password")} data-testid="agent-password-input" />
          <Button type="submit" className="rounded-xl gap-2" disabled={busy} data-testid="agent-add-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" />} إضافة
          </Button>
        </form>
      </Card>
      <Card className="divide-y divide-border">
        {agents.length === 0 ? (
          <div className="p-6 text-center text-sm text-muted-foreground" data-testid="agents-empty">لا يوجد موظفو دعم بعد</div>
        ) : agents.map((a) => (
          <div key={a.id} className="p-4 flex items-center justify-between gap-3" data-testid={`agent-row-${a.id}`}>
            <div>
              <div className="font-semibold">{a.name}</div>
              <div className="text-xs text-muted-foreground" dir="ltr">{a.email}</div>
            </div>
            <Button variant="ghost" size="icon" className="text-destructive" onClick={() => remove(a)} data-testid={`agent-delete-${a.id}`}>
              <Trash2 className="w-4 h-4" />
            </Button>
          </div>
        ))}
      </Card>
    </div>
  );
}
